import React, { FC } from 'react'
import { CSSProperties } from 'styled-components'
import { FeaturesStyle } from './FeaturesStyle'

export interface FeaturesProps {
  /**
   * Features is an array which contains all the features of string type
   */
  features: string[]
  style?: CSSProperties
}

/**
 * Component that displays features using un-order list and styled component.
 */
const Features: FC<FeaturesProps> = ({ style, features }) => {
  return (
    <FeaturesStyle style={style}>
      {features && features.map((feature) => <li key={feature}>{feature}</li>)}
    </FeaturesStyle>
  )
}

export default Features
